const DEFAULT_COUNTRY_ISO_CODE = "IN";
const DEFAULT_ERROR_MSG = "Something went wrong, please try again";

const AAKASH_STATIC_PATH = process.env.NEXT_PUBLIC_AAKASH_URL;
export const PRIVACY_POLICY_PATH = `${AAKASH_STATIC_PATH}/privacypolicy`;
export const TERMS_AND_CONDITIONS_PATH = `${AAKASH_STATIC_PATH}/termsconditions`;

const RESEND_OTP_TIME = 30;

const DEFAULT_COUNTRY = {
  isoCode: "IN",
  phoneCode: 91,
  name: "India",
  currencyCode: "INR",
};

const DESIGNATIONS = [
  "Owner",
  "Director/Trustee",
  "Principal",
  "Teacher",
  "Parent",
  "Student",
  "Other",
];

const NON_AUTH_URIS = [
  "/api/health-check/",
  "/static/",
  "/favicon.ico",
  "/app-download/",
  "/android-app/",
  "/logout/",
  "/images/",
  "/fonts/",
];

export const EMAIL_VERIFICATION_STATUS = {
  VERIFIED: "verified",
  UNVERIFIED: "unverified",
  PENDING: "pending",
};

export const PHONE_OTP_SENT_MESSAGE =
  "OTP has been successfully sent to your registered Mobile No.";

const STATIC_PATH = "../../../src/Assets/";

export const PRODUCT_LOGIN_TOUR_DETAILS = [
  {
    heading: "Welcome to Aakash Guru",
    description: "",
    imgUrl:
      "https://d29zr2abydv3bb.cloudfront.net/lcmsnode/QuestionImages/Aakash_guru_logo_white.png",
  },
];

export const PRODUCT_SIGNUP_TOUR_DETAILS = [
  {
    heading: "Welcome to Aakash",
    description:
      "Sign up to get access to free content for your entrance exam preparation.",
    imgUrl: `${STATIC_PATH}images/login-carousel-1.webp`,
  },
];

export default {
  DEFAULT_COUNTRY_ISO_CODE,
  DEFAULT_ERROR_MSG,
  DEFAULT_COUNTRY,
  DESIGNATIONS,
  RESEND_OTP_TIME,
  NON_AUTH_URIS,
};
